module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup"
  }, [(_vm.preloaderShow) ? _c('Preloader') : _vm._e(), _vm._v(" "), (_vm.errorPopup) ? _c('ErrorModal', {
    attrs: {
      "title": "Error",
      "message": "An error occurred."
    },
    on: {
      "dismissError": _vm.dismissError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayLanding) ? _c('Landing', {
    on: {
      "nextStep": _vm.nextStep
    }
  }) : _c('div', {
    staticClass: "signup__container"
  }, [_c('div', {
    staticClass: "signup__step"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v(_vm._s(_vm.stepIdx + 1))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.stepComponent.length))])]), _vm._v(" "), _c(_vm.stepComponent[_vm.stepIdx], {
    tag: "component",
    on: {
      "nextStep": _vm.nextStep,
      "showLoading": _vm.showLoading,
      "dismissLoading": _vm.dismissLoading,
      "showError": _vm.showError
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c04c5f5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-pages/Signup.vue
// module id = 546
// module chunks = 1